import MaineHeroSection from "./components/HeroSection";
import MaineCitiesDirectory from "./components/CitiesDirectory";
import MaineStateResources from "./components/StateResources";
import MaineFAQSection, { faqs } from "./components/FAQSection";
import MaineFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const maineServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function MainePage() {
  return (
    <>
      <CitySEOHead
        city="Maine"
        state="Maine"
        stateAbbr="ME"
        route="/states/maine"
        title="Maine Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Maine — Portland, Bangor, Bar Harbor, Lewiston. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Maine, United States"
        geoPosition="45.2538;-69.4455"
        faqs={faqs.map((f) => ({ q: f.question, a: f.answer }))}
        servicesSchema={maineServices}
      />
      <div className="font-sans">
        <MaineHeroSection />
        <MaineCitiesDirectory />
        <MaineStateResources />
        <MaineFAQSection />
        <SEOCrossLinks state="ME" />
        <MaineFinalCTA />
      </div>
    </>
  );
}